<div class="content">
  <div class="wrapper">
    <mat-card class="content-header" fxFlex="100%">
      <mat-card-header>
        <div class="material-icons" mat-card-avatar>{{icon}}</div>
        <mat-card-title>{{title}}</mat-card-title>
      </mat-card-header>
      <mat-divider></mat-divider>
      <mat-card-content style="white-space: pre-line;">
        <div [innerHTML]="content"></div>
      </mat-card-content>
    </mat-card>

  </div>
</div>
